import PropTypes from "prop-types";
import { Children, memo } from "react";
import "./Badge.scss";
import classNames from "classnames";

const Badge = ({ className, children, style, type, ...props }) => {
	const badgeClassName = classNames("badge", type && `badge--${type}`, className);

	return (
		<div className={badgeClassName} style={style} {...props}>
			{Children.toArray(children)
				.filter(child => child !== null)
				.map((item, idx) => (
					<div key={idx} className="badge__item">
						{item}
					</div>
				))}
		</div>
	);
};

Badge.propTypes = {
	style: PropTypes.object,
	children: PropTypes.node,
	type: PropTypes.oneOf(["default", "offered"]),
};

export default memo(Badge);
